import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import {
	type ApplicationConfig,
	inject,
	isDevMode,
	provideBrowserGlobalErrorListeners,
	provideZonelessChangeDetection,
} from '@angular/core';
import { provideRouter, withComponentInputBinding, withInMemoryScrolling, withViewTransitions } from '@angular/router';
import { provideServiceWorker } from '@angular/service-worker';
import {
	nexpoEventScopeInterceptor,
	provideNexpoApi,
	provideNexpoBoothApi,
	provideNexpoEventScope,
	provideNexpoMapApi,
} from '@soft2code/nexpo-lib/api';
import { NexpoWorkspace, nexpoAuthInterceptor, provideNexpoAuth } from '@soft2code/nexpo-lib/core';
import { provideNexpoI18n } from '@soft2code/nexpo-lib/i18n';
import { provideNexpoMockData } from '@soft2code/nexpo-lib/mock';
import { provideNexpoTheme } from '@soft2code/nexpo-lib/theme';
import { provideNexpoStatusMap } from '@soft2code/nexpo-lib/ui';
import { environment } from '../environments/environment';
import { routes } from './app.routes';
import { EXHIBITOR_STATUS_MAP } from './core/status/status-map';

export const appConfig: ApplicationConfig = {
	providers: [
		provideBrowserGlobalErrorListeners(),
		provideZonelessChangeDetection(),
		provideRouter(
			routes,
			withComponentInputBinding(),
			// A carga inicial encadeia redirects; sem isto a transição anterior é
			// abortada e o console reclama a cada abertura.
			withViewTransitions({ skipInitialTransition: true }),
			withInMemoryScrolling({ scrollPositionRestoration: 'enabled', anchorScrolling: 'enabled' })
		),
		provideHttpClient(withFetch(), withInterceptors([nexpoAuthInterceptor, nexpoEventScopeInterceptor])),

		provideNexpoApi({ baseUrl: environment.apiUrl, application: 'NEXPO-EXPOSITOR' }),
		provideNexpoAuth({ loginPath: '/sign-in', homePath: '/performance' }),
		provideNexpoTheme({ defaultPreference: 'light', storageKey: 'nexpo_expositor_theme' }),
		provideNexpoI18n({ storageKey: 'nexpo_expositor_language' }),

		// A API escopa por feira e o token do expositor não diz qual é: a escolha
		// é dele, na tela de feiras, e o escopo sai de lá.
		provideNexpoEventScope(() => inject(NexpoWorkspace).activeId()),

		...(environment.useMockData ? [provideNexpoMockData({ latencyMs: 280, anchorToday: true })] : []),
		// **Depois** do mock: os dois fornecem as mesmas portas, e o último vence.
		// Estande e desenho vêm da API de verdade — o portal tem sessão.
		provideNexpoMapApi(),
		provideNexpoBoothApi(),

		provideNexpoStatusMap(EXHIBITOR_STATUS_MAP),

		// No estande o wi-fi de feira oscila: o service worker mantém a interface.
		provideServiceWorker('ngsw-worker.js', {
			enabled: !isDevMode(),
			registrationStrategy: 'registerWhenStable:30000',
		}),
	],
};
